import cn from "classnames";
import Image from "next/image";
import { Fragment } from "react";
import Grid from "../Grid";
import Link from "../Link";
import { Text } from "../Text";
import ThemeWrapper from "../ThemeWrapper";
const CUSTOMER_STORY_IMAGE_WIDTH = 624;
const CUSTOMER_STORY_IMAGE_HEIGHT = 624;

export type HeroWithBreadcrumbProps = {
  breadcrumbItems?: {
    label: string;
    href: string;
  }[];
  companyName: string;
  title: string;
  image: {
    src: string;
    alt: string;
  };
  className?: string;
};

export const HeroWithBreadcrumb = ({
  breadcrumbItems = [],
  companyName,
  title,
  image,
  className,
}: HeroWithBreadcrumbProps) => {

  return (
    <ThemeWrapper theme='theme-dark-violet'>
      <section
        className={cn(
          "surface-l0 py-margin-section-md",
          className
        )}
      >
        <Grid className="items-center gap-y-spacing-48 md:gap-y-0">
          <div className="flex flex-col gap-xl col-span-4 md:col-span-5">
            <nav
              className="flex gap-[5px] lg:gap-[10px] text-micro1 text-blue-100 uppercase"
              aria-label="Breadcrumb"
            >
              {breadcrumbItems.map((item, index) => (
                <Fragment key={`${item.label}-${index}`}>
                  <Link href={item.href}>
                    <Text type="micro1" className="underline underline-offset-4" as="span">
                      {item.label}
                    </Text>
                  </Link>
                  {index < breadcrumbItems.length - 1 && (
                    <span className="text-citron-500">→</span>
                  )}
                </Fragment>
              ))}
              {breadcrumbItems.length > 0 && (
                <span className="text-citron-500">→</span>
              )}
              <Text type="micro1" as="span">
                {companyName}
              </Text>
            </nav>

            <Text as="h1" type='h1' className="text-violet-100">
              {title}
            </Text>
          </div>

          <div className="relative aspect-square col-span-4 md:col-span-6 overflow-hidden rounded-16 md:mt-0 md:col-start-7">
            <Image
              src={image.src}
              alt={image.alt}
              width={CUSTOMER_STORY_IMAGE_WIDTH}
              height={CUSTOMER_STORY_IMAGE_HEIGHT}
              className="h-full w-full object-cover"
            />
          </div>
        </Grid>
      </section>
    </ThemeWrapper>
  );
};
